(() => {
  'use strict';

  const selector = '[id$="__judge_me_reviews_testimonials_carousel_VjenXV"]';
  const guards = new WeakMap();

  function attach(slot) {
    if (guards.has(slot)) return;
    const widget = slot.querySelector('.jdgm-testimonials-carousel');
    if (!widget) return;

    let timer;
    let missingSince = 0;
    let retried = false;
    const started = performance.now();
    const summary = document.createElement('div');
    summary.className = 'pg-home-reviews-summary';
    summary.setAttribute('role', 'region');
    const label = widget.getAttribute('aria-label');
    if (label) summary.setAttribute('aria-label', label);
    const rating = widget.querySelector('.jdgm-rating-text');
    if (rating && Number(widget.querySelector('.jdgm-reviews-count')?.textContent) > 0) {
      summary.appendChild(rating.cloneNode(true));
      slot.appendChild(summary);
    }

    function ready() {
      return !widget.classList.contains('jdgm-hidden') &&
        !!widget.querySelector('.jdgm-testimonial');
    }

    function update() {
      const loaded = ready();
      summary.hidden = loaded;
      slot.dataset.pgHomeReviewsState = loaded ? 'ready' :
        performance.now() - started >= 20000 ? 'fallback' : 'waiting';
      if (loaded) clearTimeout(timer);
      return loaded;
    }

    // Keep the provider's own initializer. Only repair its expired builder wait.
    function tick() {
      if (!slot.isConnected || update()) return;
      const elapsed = performance.now() - started;
      if (elapsed >= 20000) return;
      const baseReady = window.jdgmCarouselUtils && window.jdgmCarouselMode;
      const builderMissing = typeof window.jdgmBuildTestimonialCards !== 'function';
      if (!baseReady || !builderMissing) missingSince = 0;
      else if (!missingSince) missingSince = performance.now();

      if (!retried && missingSince && performance.now() - missingSince >= 1300 &&
          !window.jdgm?._blocked) {
        const css = slot.querySelector('link[href*="/assets/carousels.css"]');
        if (css) {
          const url = new URL('testimonials_carousel.js', css.href);
          const completed = performance.getEntriesByName(url.href)
            .some(entry => entry.responseEnd > 0);
          if (url.origin === 'https://cdn.shopify.com' &&
              url.pathname.startsWith('/extensions/') && completed) {
            retried = true;
            slot.dataset.pgHomeReviewsRetry = '1';
            const script = document.createElement('script');
            script.src = url.href;
            script.async = true;
            script.dataset.pgHomeReviewsRetry = '1';
            document.head.appendChild(script);
          }
        }
      }
      timer = setTimeout(tick, 100);
    }

    const observer = new MutationObserver(update);
    observer.observe(widget, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    guards.set(slot, () => { clearTimeout(timer); observer.disconnect(); });
    tick();
  }

  function initialize(root) {
    root.querySelectorAll(selector).forEach(attach);
  }

  document.addEventListener('pg:reviews:mounted', event => initialize(event.target));
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(slot => {
      guards.get(slot)?.();
      guards.delete(slot);
    });
  });
})();
